// Tipi di contenuto + helper condivisi dei viewer artefatto (split del
// vecchio registry monolitico — Task #3817). Ogni viewer legge `content`
// in modo difensivo (`Partial<...>` + type guard): contenuto malformato
// produce SEMPRE un fallback visibile, mai un crash.

export interface MarkdownContent { format?: 'markdown'; body: string }
export interface CodeContent { language: string; body: string }
export interface ChartContent { type: 'pie' | 'bar' | 'line' | 'area'; title?: string; data: Array<Record<string, unknown>>; xKey?: string; yKey?: string }
export interface TableContent { columns: Array<{ key: string; label: string; type?: string }>; rows: Array<Record<string, unknown>> }
export interface ActionContent { intent: string; description: string; toolName?: string; args?: Record<string, unknown>; cta?: string; destructive?: boolean }
export interface FileContent { url?: string; name: string; mimeType: string; size?: number; preview?: string }
export interface ImageContent { url: string; alt?: string; width?: number; height?: number }
export interface VideoContent { url: string; poster?: string; durationSec?: number }
export interface AudioContent { url: string; durationSec?: number; transcript?: string }
export interface HtmlContent { body: string; sandboxed?: boolean }
export interface ReactContent { body: string; imports?: string[] }
export interface FormFieldContent {
  name: string;
  label: string;
  type: 'text' | 'number' | 'email' | 'select' | 'textarea' | 'checkbox' | 'date';
  required?: boolean;
  options?: Array<{ value: string; label: string }>;
  defaultValue?: string | number | boolean;
}
export interface FormContent { fields: FormFieldContent[]; submitLabel?: string; toolName?: string }
export interface DiagramContent { syntax?: 'mermaid'; body: string }
export interface MapContent { center: [number, number]; zoom: number; markers?: Array<{ lat: number; lng: number; label?: string }> }
export interface TimelineItem { id: string; date: string; title: string; description?: string }
export interface TimelineContent { items: TimelineItem[] }
export interface KanbanCard { id: string; title: string; description?: string }
export interface KanbanContent { columns: Array<{ id: string; title: string; cards: KanbanCard[] }> }
export interface MindmapNode { id: string; label: string; children?: MindmapNode[] }
export interface MindmapContent { root: MindmapNode }

export function isObj(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null;
}

export function formatBytes(bytes?: number): string {
  if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatDuration(sec?: number): string {
  if (typeof sec !== 'number' || !Number.isFinite(sec) || sec < 0) return '';
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}
